import { ComponentPropsWithoutRef, ReactNode } from 'react';

import { RiArrowUpLine } from '@remixicon/react';
import classNames from 'classnames';

import styles from './TableSortLabel.module.css';

export type TableSortLabelProps = Omit<
  ComponentPropsWithoutRef<'button'>,
  'type' | 'children'
> & {
  active?: boolean;
  direction?: 'asc' | 'desc';
  hideInactiveIcon?: boolean;
  onClick?: () => void;
  children: ReactNode;
  className?: string;
};

export const TableSortLabel = ({
  active = false,
  direction = 'asc',
  hideInactiveIcon = false,
  onClick,
  children,
  className,
  ...rest
}: TableSortLabelProps) => {
  return (
    <button
      data-track-source-anchor="ffa8054a51;table-sort-label-button;low" {...rest}
      type="button"
      className={classNames(
        styles.root,
        active && styles.active,
        hideInactiveIcon && styles.hideInactiveIcon,
        className,
      )}
      onClick={onClick}
    >
      {children}
      <span
        className={classNames(
          styles.icon,
          direction === 'asc' && styles.iconAsc,
          direction === 'desc' && styles.iconDesc,
        )}
        aria-hidden
      >
        <RiArrowUpLine size={16} />
      </span>
    </button>
  );
};
